module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [(_vm.from === 'case-core' || _vm.from === 'case-chain' || _vm.from === 'case-institution' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "手机号码或邮箱"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'download-core' || _vm.from === 'download-home' || _vm.from === 'download-institution') ? _c('el-input', {
    attrs: {
      "placeholder": "邮箱地址"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-core' || _vm.from === 'case-institution' || _vm.from === 'download-home' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "怎么称呼您"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-core' || _vm.from === 'case-chain' || _vm.from === 'download-core' || _vm.from === 'download-home' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "您的公司名称"
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-institution' || _vm.from === 'download-institution') ? _c('el-input', {
    attrs: {
      "placeholder": "您所在金融机构名称"
    },
    model: {
      value: (_vm.institutionName),
      callback: function($$v) {
        _vm.institutionName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "institutionName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-chain') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业角色类型"
    },
    model: {
      value: (_vm.companyPart),
      callback: function($$v) {
        _vm.companyPart = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyPart"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "我是经销商",
      "value": "经销商"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是供应商",
      "value": "供应商"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-home') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业类型"
    },
    model: {
      value: (_vm.companyType),
      callback: function($$v) {
        _vm.companyType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "我是上市公司/大型国企",
      "value": "上市公司/大型国企"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是银行",
      "value": "银行"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是供应商/经销商",
      "value": "供应商/经销商"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-core') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业行业类型"
    },
    model: {
      value: (_vm.industryType),
      callback: function($$v) {
        _vm.industryType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "industryType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "建筑工程行业",
      "value": "建筑工程行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "医药流通行业",
      "value": "医药流通行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "零售行业",
      "value": "零售行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "新能源行业",
      "value": "新能源行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制造行业",
      "value": "制造行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "物流行业",
      "value": "物流行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他行业",
      "value": "其他行业"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-institution') ? _c('el-select', {
    attrs: {
      "placeholder": "您所在金融机构属于"
    },
    model: {
      value: (_vm.institutionPart),
      callback: function($$v) {
        _vm.institutionPart = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "institutionPart"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "银行",
      "value": "银行"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非银行金融机构",
      "value": "非银行金融机构"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    style: (_vm.disabled ? 'background: #6894f9;' : 'background: #1F5DEA;'),
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ed76a51e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/ModelForm.vue
// module id = 1395
// module chunks = 26